import React, { useReducer, useEffect, useContext } from 'react';
import ParametrosContext from './ParametrosContext';
import ParametrosReducer from './ParametrosReducer';
import TokenContext from '../Token/TokenContext';
import {GET_COMUNAS, GET_PARAM, GET_REGIONID } from '../type';
import clienteAxios from '../../Utils/axios';

const ParametrosState = props =>{
    const initialState = {
        parametros: [],
        comunas: [],
        regionId: 0,
    };

    
    const tokenContext = useContext(TokenContext)
    const { token  } = tokenContext;

    const [state,dispatch] = useReducer(ParametrosReducer, initialState);
 
    const Get_Parametros_F = params => {
        dispatch({
            type: GET_PARAM,
            payload: params
        })
    }

    const Get_Comunas_F = comunas => {
        dispatch({
            type: GET_COMUNAS,
            payload: comunas
        })
    }

    const Get_RegionId_F = id => {
        dispatch({
            type: GET_REGIONID,
            payload: id
        })
    }

    useEffect(() => {
        const getParam = async () =>{
            

            try {
                const res = await clienteAxios.get('/Parametros/', {
                    headers: {
                      Authorization: "Bearer " + token,
                      accept: "application/json",
                      "Content-Type": "multipart/form-data",
                    },
                  });
                Get_Parametros_F(res.data)
            } catch (error) {
                console.log(error)
            }
        }
        
        if(token !== null && token !== "" && token !== "undefined" && token !== undefined){
            
            if(state.parametros.length === 0){
            getParam()
            }
        }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token])
 
    useEffect(() => {

        const getComunas = async () =>{
            try {
                const dataForm = new FormData()
                dataForm.append("regionId", state.regionId)

                const res = await clienteAxios.post('/Comunas/', dataForm);
                Get_Comunas_F(res.data)
            } catch (error) {
                console.log(error)
            }
        }
        getComunas();

    }, [state.regionId])

    return (
        <ParametrosContext.Provider 
        value = {{
            parametros: state.parametros,
            comunas: state.comunas,
            regionId: state.regionId,
            Get_RegionId_F

        }}>
            { props.children }
        </ParametrosContext.Provider>
    )
};

export default ParametrosState